module.exports = "/_next/static/images/designbottom-8d30ba67e0f638793e54d15e585ac2de.png";